import EdudoResponse from '../models/edudo-response';
import HttpService from './http-service';

export default class AbsenceService {
  private schoolUuid: string;

  constructor(schoolUuid: string) {
    this.schoolUuid = schoolUuid;
  }

  private basePath(): string {
    return `/v1/schools/${this.schoolUuid}/absences`;
  }

  private backofficeBasePath(): string {
    return `/school-backoffice-bff/v1/schools/${this.schoolUuid}`;
  }

  // Tudo ou nada: um dia já ocupado (diário ou falta) devolve 409 e nenhuma falta é registrada.
  async registerAbsences(data: RegisterAbsencesRequest): Promise<void> {
    await HttpService.postJson<EdudoResponse<unknown>>(this.basePath(), data);
  }

  async justifyAbsence(absenceId: string, data: JustifyAbsenceRequest): Promise<void> {
    await HttpService.putJson<EdudoResponse<unknown>>(`${this.basePath()}/${absenceId}/justification`, data);
  }

  // Sem atestado: o atestado é de um aluno, então vai por justifyAbsence.
  async justifyAbsences(data: JustifyAbsencesRequest): Promise<void> {
    await HttpService.putJson<EdudoResponse<unknown>>(`${this.basePath()}/justifications`, data);
  }

  async deleteAbsences(absenceIds: string[]): Promise<DeleteAbsencesResponse> {
    const response = await HttpService.deleteJson<EdudoResponse<DeleteAbsencesResponse>>(this.basePath(), {
      absenceIds,
    });

    return response.data;
  }

  // from/to são dias da escola ("yyyy-MM-dd"), inclusivos.
  async listClassroomAbsences(classroomUuid: string, from: string, to: string): Promise<Absence[]> {
    const response = await HttpService.getJson<EdudoResponse<Absence[]>>(
      `${this.backofficeBasePath()}/classrooms/${classroomUuid}/absences?from=${from}&to=${to}`
    );

    return response.data;
  }
}
